import moment from 'moment';

const toDayIsoString = (value: unknown): string =>
	moment(value as any)
		.startOf('day')
		.utcOffset(0, true)
		.toISOString();

export const isBlob = (value: unknown): value is Blob =>
	typeof Blob !== 'undefined' && value instanceof Blob;

export const normalizeWizardFormValues = (data: any): any => {
	if (isBlob(data)) {
		return data;
	}

	if (typeof FileList !== 'undefined' && data instanceof FileList) {
		return Array.from(data);
	}

	if (data && typeof data === 'object' && data._isAMomentObject) {
		try {
			return toDayIsoString(data);
		} catch {
			const d = data?._d;
			if (d instanceof Date) return toDayIsoString(d);
			return d ?? null;
		}
	}

	if (data instanceof Date) {
		return toDayIsoString(data);
	}

	if (Array.isArray(data)) {
		return data.map(normalizeWizardFormValues);
	}

	if (data && typeof data === 'object') {
		if ('value' in data && Object.keys(data).length <= 3) {
			return normalizeWizardFormValues(data.value);
		}

		const result: Record<string, any> = {};
		for (const key in data) {
			result[key] = normalizeWizardFormValues(data[key]);
		}
		return result;
	}

	return data;
};
